import React, { Suspense } from "react";
import Cookies from "js-cookie";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "./App.scss";
import "../main.css";
import ExternalFatEle from "./External/ExternalFatEle";
import ExternalData from "./External/ExternalData";

import IncentivarFaturaEletronicaTodos from "./External/IncentivarFaturaEletronicaTodos";
import ClientNew from "./Client/ClientNew";
const Portal = React.lazy(() => import("./Portal"));
const Login = React.lazy(() => import("./Login"));



class App extends React.Component {
  constructor(prop) {
    super(prop);

    if (Cookies.get("authtoken")) {
      this.state = {
        userLogged: true
      };
    } else {
      this.state = {
        userLogged: false
      };
    }
  }

  render() {
    const { userLogged } = this.state;
  
    if (userLogged  ) {
      return (
        <Suspense fallback={<h2>A carregar...</h2>}>
          <Portal />
        </Suspense>
      );
    } else {
      return (
        <Router>
          <Switch>
        
            <Route
              exact
              path="/approveelectronicbilling/:tokenId"
              component={ExternalFatEle}
            ></Route>
             <Route
              exact
              path="/StartYourElectronicBillingNow/:tokenId"
              component={IncentivarFaturaEletronicaTodos}
            ></Route>
            <Route
              exact
              path="/changeselfdata/:tokenId"
              component={ExternalData}
            ></Route>
              <Route
              exact
              path="/changeclientdata/:tokenId"
              component={ExternalData}
            ></Route>
            <Route path="/">
              <Suspense fallback={<h2>A carregar...</h2>}>
                <Login userLogged={this.state.userLogged} />
              </Suspense>
            </Route>
          </Switch>
        </Router>
      );
    }
  }
}


export default App;
